"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Loader2 } from "lucide-react";
export default function FormularioContacto() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="contacto-formulario" id="formulario" className="bg-background text-foreground py-24 md:py-32 overflow-hidden border-t border-border/30">
      <div className="container mx-auto px-6 md:px-8 max-w-3xl">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal text-foreground leading-tight mb-6">Escríbenos.</h2>

          <p className="font-sans text-lg text-muted-foreground leading-relaxed mb-12 max-w-2xl">Respondemos en menos de 24 horas hábiles. Si tienes contexto operativo concreto que quieras que veamos antes de la llamada, mejor.</p>

          <FormProvider formId="contact_form_contact" sectionName="AboutMe" defaultValues={{
          nombre: "",
          empresa: "",
          correo: "",
          rol: "",
          mensaje: ""
        }} submitText="Enviar" successMessage="Mensaje enviado con éxito. Nos pondremos en contacto pronto.">
            <ContactFormInner />
          </FormProvider>

          <p className="font-mono text-xs text-muted-foreground/70 mt-8">
            Tu información no se comparte con terceros. Se usa solo para contactarte sobre tu solicitud.
          </p>
        </div>
      </div>
    </section>;
}
function ContactFormInner() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-8 border border-primary/20 bg-accent/5 rounded-sm">
        <p className="font-sans text-lg text-foreground">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="nombre" rules={{
        required: "El nombre es obligatorio"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Nombre</FormLabel>
              <FormControl>
                <Input placeholder="Tu nombre completo" className="bg-card border-border/50 focus:border-primary rounded-sm" {...field} />
              </FormControl>
              <FormMessage className="text-xs font-mono" />
            </FormItem>} />

        <FormField control={control} name="empresa" rules={{
        required: "La empresa es obligatoria"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Empresa</FormLabel>
              <FormControl>
                <Input placeholder="Nombre de tu empresa" className="bg-card border-border/50 focus:border-primary rounded-sm" {...field} />
              </FormControl>
              <FormMessage className="text-xs font-mono" />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="correo" rules={{
        required: "El correo es obligatorio",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Correo electrónico inválido"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Correo</FormLabel>
              <FormControl>
                <Input type="email" placeholder="hola@empresa.com" className="bg-card border-border/50 focus:border-primary rounded-sm" {...field} />
              </FormControl>
              <FormMessage className="text-xs font-mono" />
            </FormItem>} />

        <FormField control={control} name="rol" render={({
        field
      }) => <FormItem>
              <FormLabel className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Tu rol en la empresa (Opcional)</FormLabel>
              <FormControl>
                <Input placeholder="Ej. Director de Operaciones" className="bg-card border-border/50 focus:border-primary rounded-sm" {...field} />
              </FormControl>
              <FormMessage className="text-xs font-mono" />
            </FormItem>} />
      </div>

      <FormField control={control} name="mensaje" rules={{
      required: "Por favor, cuéntanos qué está pasando"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Qué está pasando</FormLabel>
            <FormControl>
              <Textarea placeholder="Describe brevemente el desafío técnico u operativo..." rows={6} className="bg-card border-border/50 focus:border-primary rounded-sm resize-none" {...field} />
            </FormControl>
            <FormMessage className="text-xs font-mono" />
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-sm">
          <p className="text-destructive text-sm font-sans">{submitError}</p>
        </div>}

      <div className="pt-4">
        <Button type="submit" disabled={isSubmitting} className="w-full md:w-auto px-12 py-6 bg-primary text-primary-foreground hover:bg-primary/90 rounded-sm font-sans font-medium transition-colors">
          {isSubmitting ? <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Enviando...
            </> : "Enviar"}
        </Button>
      </div>
    </Form>;
}